import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CATEGORY_IMAGES } from "@/constants/categoryImages";

export function CategoryHero({ activeCat, active, onBack }) {
  return (
    <motion.div key={active} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
      className="relative overflow-hidden rounded-3xl card-soft p-8 lg:p-10 text-white" style={{ backgroundColor: "#291B2D" }} data-testid="category-hero">
      <img src={CATEGORY_IMAGES[active]} alt="" className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: "50% 25%" }} />
      <div className="absolute inset-0 bg-gradient-to-r from-[#291B2D] via-[#291B2D]/85 to-[#291B2D]/40" />
      <div className="relative z-10">
        <button onClick={onBack} data-testid="cat-back-to-all"
          className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-white/70 hover:text-white transition-smooth mb-3">
          <ArrowRight size={13} className="rotate-180" /> All courses
        </button>
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#C89B55] font-semibold">Area</p>
        <h2 className="font-heading text-3xl lg:text-4xl mt-1">{activeCat.title}</h2>
        <p className="text-white/85 mt-2 max-w-xl">{activeCat.description}</p>
      </div>
    </motion.div>
  );
}
